import React from "react";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import { getVisibleOnlyOnDesktopResolver } from "./../plugin-commons";
import { AlignmentPanel, NodeAlignmentButton } from "./../toolbars-ui";
import { buttonsModals } from "./constants";
import ButtonSettingsModal from "./modals/SettingsModal";
const getToolbarButtons = (config, services, type) => {
  const {
    context: { isMobile }
  } = services;
  const alignment = buttonsModals.alignment[type];
  const settings = buttonsModals.settings[type];
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
        active: {
          id: "IS_BUTTON_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals }) => Boolean(modals.getModal(settings))
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        Component: decorateComponentWithProps(ButtonSettingsModal, {
          modalId: settings
        }),
        id: settings
      },
      command: ({ isMobile: isMobile2, attributes: { selectedNode } }) => {
        services.modals.openRegisteredModal(settings, {
          componentProps: {
            nodeId: selectedNode.attrs.id,
            settings: config,
            type
          },
          positioning: { placement: "right" },
          layout: isMobile2 ? "fullscreen" : "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
